<app-modal *ngIf="vo$ | async; let vo">
	<div
		modal-body
		class="app-filter-model-confirm-popup">
		<div class="app-filter-model-confirm-popup__element">
			<ng-container *ngIf="!vo.isMultipleElement">
				<span
					i18n="@@subscription.filterModel.action.confirm.popup.concernedElement">
					concerned-element</span>

				<span class="app-filter-model-confirm-popup__element-label">
					{{ vo.element | truncate: 30: 1 : 'end' }}</span>
			</ng-container>

			<ng-container *ngIf="vo.isMultipleElement">
				<span
					i18n="@@subscription.filterModel.action.confirm.popup.concernedElements">
					concerned-elements</span>

				<div class="app-filter-model-confirm-popup__element-label">
					{{ vo.filterModelId.length }}
					<span
						i18n="@@subscription.filterModel.action.confirm.popup.filterModels">
						filter-models</span>
				</div>
			</ng-container>
		</div>

		<ng-container [ngSwitch]="vo.action">
			<div *ngSwitchCase="FilterModelAction.Delete"
					 class="app-filter-model-confirm-popup__delete">
				<ng-container>
					<span
						*ngIf="!vo.isMultipleElement"
						class="app-filter-model-confirm-popup__description"
						i18n="@@subscription.filterModel.action.confirm.popup.delete.description">
						deletion-request
					</span>
					<span
						*ngIf="vo.isMultipleElement"
						class="app-filter-model-confirm-popup__description"
						i18n="@@subscription.filterModel.action.confirm.popup.delete.multiple.description">
						deletion-multiple-request
					</span>
				</ng-container>

				<dc-alert
					*ngIf="!vo.isMultipleElement"
					type="error"
					message="info"
					i18n-message="@@subscription.filterModel.action.confirm.popup.delete.info">
				</dc-alert>

				<dc-alert
					*ngIf="vo.isMultipleElement"
					type="error"
					message="multiple-info"
					i18n-message="@@subscription.filterModel.action.confirm.popup.delete.multiple.info">
				</dc-alert>

				<div class="app-filter-model-confirm-popup__checkbox">
					<mat-checkbox
						id="{{ cmpId }}-confirm-delete-checkbox"
						color="primary"
						[(ngModel)]="confirmDeletion">
						<span
							i18n="@@subscription.filterModel.action.confirm.popup.delete.confirm">
							confirm-delete
						</span>
					</mat-checkbox>
				</div>
			</div>
		</ng-container>
	</div>

	<div modal-footer  class="app-filter-model-confirm-popup__footer">
		<ng-container [ngSwitch]="vo.action">
			<button
				*ngSwitchCase="FilterModelAction.Delete"
				id="{{ cmpId }}-delete-btn"
				class="app-filter-model-confirm-popup__footer__btn"
				[color]="'warn'"
				[disabled]="!confirmDeletion"
				(click)="launchAction()"
				mat-raised-button>
				<mat-icon [svgIcon]="DcIcons.Delete"></mat-icon>
				<span
					i18n="@@subscription.filterModel.action.confirm.popup.delete.btn">
					delete
				</span>
			</button>
		</ng-container>
	</div>
</app-modal>
